import appsRetina from 'marketing-website/media/images/pages/apple-watch-prototyping/apps@2x.jpg';
import appStoreRetina from 'marketing-website/media/images/pages/apple-watch-prototyping/app-store@2x.png';
import watchRetina from 'marketing-website/media/images/pages/apple-watch-prototyping/watch@2x.jpg';
import filesRetina from 'marketing-website/media/images/pages/apple-watch-prototyping/files@2x.jpg';

const assets = {
  apps: {
    alt: 'Marvel mobile apps for prototyping',
    maxWidth: 700,
    src: appsRetina,
    hasShadow: false,
  },
  appStore: {
    alt: 'Apple App Store',
    maxWidth: 180,
    src: appStoreRetina,
    hasShadow: false,
  },
  watch: {
    alt: 'Apple Watch illustration',
    maxWidth: 174,
    src: watchRetina,
    hasShadow: false,
  },
  files: {
    alt: 'Supported files illustration',
    maxWidth: 280,
    src: filesRetina,
    hasShadow: false,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/apple-watch-prototyping/assets.js